import { useEffect, useRef } from "react";
import type { IInfoCard } from "@app/dashboard/types/innerLayout/cards/info-card";
import { CircleInfo } from "@unified-checkout/design-system/icons/index";
import { Tooltip } from "@unified-checkout/design-system";
import { Card } from "../CardWrapper";
import styles from "./info-card.module.scss";

export const InfoCard = ({
  width,
  height,
  title,
  noOfColumns = 1,
  pairsList,
  onClickHandler
}: IInfoCard) => {
  const containerRef = useRef<any>();

  useEffect(() => {
    containerRef.current && containerRef.current.style.setProperty("--no-of-columns", noOfColumns);
  }, [noOfColumns]);

  return (
    <Card
      width={width}
      height={height}
      title={title}
      onClickHandler={onClickHandler}
    >
      <div className={styles["pairs-box"]} ref={containerRef}>
        {
          pairsList?.map((pair, index) =>
            <div
              className={styles["pairs-box__pair"]}
              key={`info-card-pair-${index}`}
            >
              {
                pair.label &&
                <div className={styles["pairs-box__pair__label"]}>
                  {typeof pair.label === 'string' ? pair.label : pair.label.text}
                  {
                    pair?.toolTipProps &&
                    <Tooltip
                      {...pair.toolTipProps || {}}
                    >
                      <div className={styles["pairs-box__pair__label__tooltip-icon"]}>
                        {CircleInfo}
                      </div>
                    </Tooltip>
                  }
                </div>
              }
              {
                pair.render ? pair?.render() :
                  (pair.value || pair.leading_icon) &&
                  <div className={styles["pairs-box__pair__value"]}>
                    {
                      pair.leading_icon &&
                      <div className={styles["pairs-box__pair__value__leading-icon"]}>
                        {
                          typeof pair.leading_icon === 'string' ?
                            <img
                              src={pair.leading_icon}
                              alt={
                                typeof pair.value === 'string'
                                  ? pair.value
                                  : typeof pair.label === 'string'
                                    ? pair.label
                                    : pair.label?.text
                              }
                            />
                            :
                            pair.leading_icon
                        }
                      </div>
                    }

                    {pair.value}

                    {
                      pair.trailing_icon &&
                      <div className={styles["pairs-box__pair__value__trailing-icon"]}>
                        {pair.trailing_icon}
                      </div>
                    }
                  </div>
              }

            </div>
          )
        }
      </div>
    </Card>
  )
};